import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";

import { MatxTheme } from "./components";
// ALL CONTEXTS
import { AuthProvider } from "./contexts/JWTAuthContext";
import SettingsProvider from "./contexts/SettingsContext";
import { RecentSearchProvider } from "./contexts/RecentSearchContext";
// ROUTES
import routes from "./routes";
// FAKE SERVER
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NotificationProvider } from "./contexts/NotificationContext";
import { SnackbarProvider } from "notistack";
import RouteMeta from "./components/RouteMeta";

const queryClient = new QueryClient();

export default function App() {
  const content = useRoutes(routes);
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <AuthProvider>
          <SnackbarProvider>
            <NotificationProvider>
              <MatxTheme>
                <CssBaseline />
                <RouteMeta />
                <RecentSearchProvider>{content}</RecentSearchProvider>
              </MatxTheme>
            </NotificationProvider>
          </SnackbarProvider>
        </AuthProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
}
